// format 500 as $5.00
export const standard = {
  exponent: -2
};
export const BHD = {
  exponent: -3
};

// format 200_000_000 as 2 BTC
export const BTC = {
  exponent: -8
};

// e.g. format 500 JPY as ¥500
export const CLP = {
  exponent: 0
};
export const JOD = {
  exponent: -3
};
export const JPY = {
  exponent: 0
};
export const KWD = {
  exponent: -3
};
export const OMR = {
  exponent: -3
};
export const MGA = {
  exponent: 0
};
export const MRO = {
  exponent: 0
};
export const KRW = {
  exponent: 0
};
export const TND = {
  exponent: -3
};
export const VND = {
  exponent: 0
};